"use client";

import {
  breakpointTablet,
  IconButton,
  Heading2Text,
} from "@gnist/design-system";
import { styled } from "styled-components";
import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import { SpecificationsModal } from "@/app/bil/[carId]/components/specificationsModal";
import { useState } from "react";
import { Specifications } from "@/app/bil/[carId]/components/specifications";
import { Collapse } from "@/components/collapse";
import { isMobile } from "@/utils/isMobile";
import { tokens } from "@gnist/themes/tokens.css.js";

interface Props {
  car: Car;
}

const Wrapper = styled.div`
  max-width: 704px;

  h3 {
    padding-bottom: ${tokens.spacing.s};
    @media screen and (max-width: ${breakpointTablet}) {
      font-size: ${tokens.typeface.size.m};
    }
  }
`;

const OpenButton = styled(IconButton)`
  margin-top: ${tokens.spacing.s});
`;

export const SpecificationsSection = ({ car }: Props) => {
  const [isShowingModal, setShowModal] = useState(false);

  return (
    <Wrapper>
      <Heading2Text>Spesifikasjoner</Heading2Text>
      {isMobile() ? (
        <div>
          <Specifications car={car} showShortenedList />
          <OpenButton
            icon="chevron_right"
            label="Se alle spesifikasjoner"
            showLabel="left"
            onClick={() => setShowModal(true)}
          />
          <SpecificationsModal
            car={car}
            showSpecifications={isShowingModal}
            setShowSpecifications={setShowModal}
          />
        </div>
      ) : (
        <Collapse
          id="specifications-desktop"
          collapsedHeight="200"
          buttonLabel={{
            collapse: "Vis mindre",
            expand: "Vis alle spesifikasjoner",
          }}
          backgroundColorToken={tokens.color.background}
        >
          <Specifications car={car} />
        </Collapse>
      )}
    </Wrapper>
  );
};
